import GlobalStyle from './globalStyle'

export default GlobalStyle
